// extracted by mini-css-extract-plugin
module.exports = {"root":"AppView_root__2bz92"};